import {Routes, Route, Navigate} from "react-router-dom";

// import Home from "../pages/home/Home";
// import Join from "../pages/join";
// import Contact from "../pages/Contact";
// import Crm from '../pages/products/Crm';

import Login from '../pages/Login';
import ResetPassword from '../pages/ResetPassword';
import ForgotPassword from '../pages/ForgotPassword';
import Layout from "./Layout";

import Dashboard from "./Dashboard";
import AdminDashboard from "../admin/AdminDashboard";

import AdminRoutes from "../admin/AdminRoutes";
import ClientRoutes from "./ClientRoutes";

const userType = localStorage.getItem('userType');



const AppRoutes = () => {
    return (
    <Routes>
        {/* <Route path="/" element={ <Home/> } /> */}
        {/* <Route path="/contact" element={ <Contact/> } />   */}
        {/* <Route path="/join" element={ <Join/> } />   */}
        {/* <Route path="/products"  > 
            <Route path="crm" element={ <Crm/> }/>
        </Route> */}


        <Route path="/" element={ <Navigate to="/dashboard" replace /> } />
        <Route path="/login" element={ <Login/> } />  
        <Route path="/forgot" element={ <ForgotPassword/> } />  
        <Route path="/password/reset/:uid/:token" element={ <ResetPassword/> } />  
        <Route path="dashboard" element={<Layout />}> 
            <Route index element={<Dashboard />} />
            <Route path="*" element={<ClientRoutes />} />

            {/* {userType === 'ADM' &&
            <>
                <Route index element={<AdminDashboard />} />
                <Route path="*" element={<AdminRoutes />} />
            </>
            }
            {userType !== 'ADM' &&
            <>
                <Route index element={<Dashboard />} />
                <Route path="*" element={<ClientRoutes />} />
            </>
            } */}
        </Route>

        {/* <Route path="/dashboard/*" element={<Navigate to="/" replace />} /> */}
    </Routes>
    )
}
export default AppRoutes


